import SearchProductsPage from '../[countryCode]/product/search'
import {withRedirectForNoCountryCode} from "../../components/with_redirect_for_no_country_code";

export default withRedirectForNoCountryCode(SearchProductsPage)
